'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module1Extra4 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Extra4, _Component);

  function Module1Extra4() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Extra4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Extra4.__proto__ || (0, _getPrototypeOf2.default)(Module1Extra4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Nutrition Information Panels'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module1Extra4, [{
    key: 'render',
    value: function render() {
      var informationPanel = require('../Assets/informationPanel.png');
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h3',
            null,
            'How do I know if a food is low in fat, salt & sugar?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'All food packages have a nutrition information panel. There are different ways to check if a product is \u2018low\u2019 in fat, sugar, or salt. The general rule is the lower the better! Check for: Total fat: Generally, choose foods with less than 10 grams of fat per 100g. For milk, yoghurt and ice cream choose those with less than 2g per 100g. For cheese, choose less than 15g per 100g.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Saturated fat: Choose the option with the least saturated fat per 100g. Less than 3g per 100g is best.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sugar: Minimise added sugar where possible. Choose products which have less than 15g sugar per 100g. For drinks, choose products which have 7.5g of sugar or less per 100g. If sugar content is more than 15g per 100g, check that sugar is not high up in the ingredient list.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Salt: Foods with less than 400mg per 100g are acceptable, but less than 120mg per 100g is best.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Sample nutrition information panel'
          ),
          _react2.default.createElement(ReactBootstrap.Image, { src: informationPanel, responsive: true }),
          _react2.default.createElement('div', { className: styles.spacer40 })
        )
      );
    }
  }]);
  return Module1Extra4;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module1Extra4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Extra/Extra4.js
// module id = 1177
// module chunks = 0